// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'phone-split';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path d='M9 11.91C9 8.693 6.083 3.135 1 1m8 10.91C9 8.693 11.917 3.135 17 1M9 11.91V17' />
    <path d='M1 6.818V1h5.818M17 6.818V1h-5.818' />
  </g>
);

export const viewBox = '0 0 18 18';
